import { mapGetters } from "vuex";

export const company_info = {
  data() {
    return {
      company: {},
    };
  },
  computed: {
    ...mapGetters(["table_config"]),
  },
  methods: {
    loadConfig() {
      let item = this.loadCompanyConfig();
      if (!item) {
        return;
      }
      this.util.copyObject(item.value, this.company);
    },
    loadCompanyConfig() {
      let item = this.loadCompanyGlobalConfig();
      return item;
    },
    loadCompanyGlobalConfig() {
      return this.table_config.find((c) => c.key === "company");
    },
    updateCompanyGlobalConfig(data, handler) {
      let params = {
        key: "company",
        value: data,
      };
      this.api.updateConfig(params).then((res) => {
        handler(res);
      });
    },
  },
};
